<template>
   <div v-if="posted">
    <div class="thankspage">
      <div class="thankshead">
        <img class="thankstop" src="/img/top.png">
        <h2 class="thankstitle">ご入力ありがとうございました。<br>内容はリトル・ママの承認後、サイトに反映されます。</h2>
      </div>
      <div class="thanks">
        <p class="thankstxt">ご応募いただき<br>ありがとうございました。<br>以上で登録は完了いたしました。</p>
        <!-- <p class="thankstxt2">ご入力頂いた内容は下記の<br>URLより修正ください。</p>
        <p class="thankstxt3">※下記のURLは再発行できませんので必ず保管いただきますようお願いします。</p>
        <div class="link">
          <a class="url" :href=displayEditUrl>{{ displayEditUrl }}</a>
        </div> -->
      </div>
    </div>
  </div>
  <div v-else>
    <ProviderForm
    :provider1001="provider1001"
    @submit-form="submitForm"
    :processing="processing"
      />
  </div>
</template>

<script>
// import firebase from '@/plugins/firebase'
import ProviderForm from '@/components/templates/2021tsuruha/ProviderForm.vue'
import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/functions'
export default {
  name: 'Provider1001',
  components: {
    ProviderForm
  },
  data () {
    return {
      provider1001: {
        name: '',
        email: '',
        tel: '',
        ｍissedUrl: '',
        group_name: '',
        title: '',
        image: '',
        age: [],
        deliveryFrame: [],
        deliveryTime: '',
        detail: '',
        tool: '',
        url: '',
        reInnovateUrl: '',
        eventName: '',
        exhibitor_url1: '',
        exhibitor_url2: '',
        exhibitor_url3: '',
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        isApproved: false,
        isRejected: false,
        isHeldOnline: true,
        isAlwaysViewable: false,
        isLmaChannel: false
      },
      docId: '',
      posted: false,
      processing: false,
      editDocId: ''
    }
  },
  methods: {
    submitForm (provider1001) {
      this.provider1001 = provider1001
      if (this.editDocId) {
        this.updateProvider1001()
      } else {
        this.setProvider1001()
      }
    },
    updateProvider1001 () {
      this.processing = true
      const db = firebase.firestore()
      const dbProvider1001 = db.collection('provider1001')
      const sortedDeliveryFrame = this.provider1001.deliveryFrame.map(Number).sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      const sortedAge = this.provider1001.age.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      dbProvider1001.doc(this.editDocId)
        .update({
          ｍissedUrl: this.provider1001.ｍissedUrl,
          title: this.provider1001.title,
          age: sortedAge,
          deliveryFrame: sortedDeliveryFrame,
          deliveryTime: this.provider1001.deliveryTime,
          detail: this.provider1001.detail,
          tool: this.provider1001.tool,
          url: this.provider1001.url,
          reInnovateUrl: this.provider1001.reInnovateUrl,
          eventName: this.provider1001.eventName,
          exhibitor_url1: this.provider1001.exhibitor_url1,
          exhibitor_url2: this.provider1001.exhibitor_url2,
          exhibitor_url3: this.provider1001.exhibitor_url3
        })
        .then(ref => {
          const uuId = this.getUUid
          dbProvider1001.doc(this.editDocId).collection('secretDatas').doc('private').update({
            name: this.provider1001.name,
            email: this.provider1001.email,
            tel: this.provider1001.tel,
            uuId: uuId,
            group_name: this.provider1001.group_name
          })
          dbProvider1001.doc(this.editDocId).collection('secretDatas').doc('image').update({
            base64: this.provider1001.image
          })
          db.collection('uuids').add({
            id: uuId,
            docId: this.editDocId,
            collection: 'provider1001'
          })
          // this.sendMail()
          this.storeImage(this.editDocId).then((snapShot) => {
            snapShot.ref.getDownloadURL().then(downloadURL => {
              dbProvider1001.doc(this.editDocId).update({ imageUrl: downloadURL })
              this.processing = false
              this.posted = true
            })
          })
        })
        .catch((e) => {
          this.processing = false
          console.log(138, e)
        })
    },
    async setProvider1001 () {
      this.processing = true
      const db = firebase.firestore()
      const dbProvider1001 = db.collection('provider1001')
      const dbUUid = db.collection('uuids')
      const sortedDeliveryFrame = this.provider1001.deliveryFrame.map(Number).sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      const sortedAge = this.provider1001.age.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      dbProvider1001
        .add({
          ｍissedUrl: this.provider1001.ｍissedUrl,
          title: this.provider1001.title,
          age: sortedAge,
          deliveryFrame: sortedDeliveryFrame,
          deliveryTime: this.provider1001.deliveryTime,
          detail: this.provider1001.detail,
          tool: this.provider1001.tool,
          url: this.provider1001.url,
          reInnovateUrl: this.provider1001.reInnovateUrl,
          eventName: this.provider1001.eventName,
          exhibitor_url1: this.provider1001.exhibitor_url1,
          exhibitor_url2: this.provider1001.exhibitor_url2,
          exhibitor_url3: this.provider1001.exhibitor_url3,
          createdAt: this.provider1001.createdAt,
          isApproved: false,
          isRejected: false,
          isHeldOnline: true,
          isAlwaysViewable: false,
          isLmaChannel: false
        })
        .then(async ref => {
          console.log(ref)
          const docId = ref.id
          this.docId = docId
          const uuId = this.getUUid
          await dbProvider1001.doc(docId).collection('secretDatas').doc('private').set({
            name: this.provider1001.name,
            group_name: this.provider1001.group_name,
            email: this.provider1001.email,
            tel: this.provider1001.tel,
            uuId: uuId
          })
          await dbProvider1001.doc(docId).collection('secretDatas').doc('image').set({
            base64: this.provider1001.image
          })
          await dbUUid.add({
            id: uuId,
            docId: docId,
            collection: 'provider1001'
          })
          // await this.sendMail()
          this.storeImage(this.docId).then((snapShot) => {
            snapShot.ref.getDownloadURL().then(downloadURL => {
              dbProvider1001.doc(docId).update({ imageUrl: downloadURL }).then((snapShot) => {
                this.processing = false
                this.posted = true
              })
            })
          })
            .catch(e => {
              this.processing = false
            })
        })
    },
    async storeImage (docId) {
      const ref = `pictures/provider1001/${docId}/${this.fileName}`
      const storageRef = firebase.storage().ref().child(ref)
      return await storageRef.putString(this.provider1001.image, 'data_url')
    },
    async getProvider1001Data (docId) {
      const db = firebase.firestore()
      const dbProvider1001 = db.collection('provider1001')
      const data = await dbProvider1001.doc(docId).get().catch((e) => {
        console.log('Error getting document:', e)
      })
      const editDocId = data.id
      const allSecretData = await Promise.all([dbProvider1001.doc(editDocId).collection('secretDatas').doc('private').get(), dbProvider1001.doc(docId).collection('secretDatas').doc('image').get()])
      const privateData = allSecretData[0].data()
      const imageData = allSecretData[1].data()
      const editData = Object.assign(data.data(), privateData, { image: imageData.base64 })
      this.provider1001 = editData
    }
  //   async sendMail () {
  //     const functions = firebase.app().functions('asia-northeast1')
  //     const sendConfirmMail = functions.httpsCallable('sendConfirmMailForHybrid')
  //     sendConfirmMail({
  //       name: this.provider1001.name,
  //       email: this.provider1001.email,
  //       tel: this.provider1001.tel,
  //       group_name: this.provider1001.group_name,
  //       ｍissedUrl: this.provider1001.ｍissedUrl,
  //       title: this.provider1001.title,
  //       deliveryFrame: this.provider1001.deliveryFrame.map(Number),
  //       deliveryTime: this.provider1001.deliveryTime,
  //       age: this.provider1001.age,
  //       detail: this.provider1001.detail,
  //       tool: this.provider1001.tool,
  //       url: this.provider1001.url,
  //       reInnovateUrl: this.provider1001.reInnovateUrl,
  //       eventName: this.provider1001.eventName,
  //       exhibitor_url1: this.provider1001.exhibitor_url1,
  //       exhibitor_url2: this.provider1001.exhibitor_url2,
  //       exhibitor_url3: this.provider1001.exhibitor_url3,
  //       editUrl: this.displayEditUrl,
  //       type: 'provider'
  //     })
  //   }
  },
  computed: {
    displayEditUrl () {
      const editPath = this.$router.resolve({
        name: 'editTsuruhaProvider',
        params: {
          docId: this.getUUid
        }
      }).href
      return location.origin + editPath
    },
    getUUid () {
      return this.$store.getters.getUUid
    }
  },
  async mounted () {
    if (this.$route.params.docId) {
      const uuId = this.$route.params.docId
      const docId = await this.$store.dispatch('getDocIdByUUid', { collection: 'provider1001', uuId: uuId }).catch(e => {
        this.$router.push('/')
      })
      this.editDocId = docId
      await this.getProvider1001Data(docId)
    }
  }
}
</script>
<style lang="sass" scoped>
.thankspage
  width: 100%
  margin: 0 auto
.thankspage2
  width: 100%
  margin: 0 auto
  padding: 40px 0
.thankshead
  background-color: #FFDDE8
  width: 100%
  margin: 0 auto
.thankstop
  width: 100%
  margin: 0 auto
  font-size: 40px
  text-align: center
  padding-top: 10px
.thankstitle
  width: 100%
  margin: 0 auto
  text-align: center
  padding-bottom: 20px
.thanks
  margin: 0 25px
.thankstxt
  margin-top: 30px
  text-align: center
  font-size: 20px
  color: #707070
.thankstxt2
  font-size: 20px
  text-align: center
  color: #707070
  line-height: 25px
.thankstxt3
  font-size: 18px
  text-decoration: underline
  color: #707070
  text-align: center
  font-weight: bold
  margin-top: 10px
  line-height: 30px
.link
  text-align: center
  margin-top: 20px
  font-size: 20px
.url
  color: #3FBD92
  text-decoration: underline
</style>
